export default __webpack_public_path__ + "static/media/expand-icon.a48b972e.svg";